/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DatahubLoaderParamsBcLevelMapping } from '../models/DatahubLoaderParamsBcLevelMapping';
import type { DatahubLoaderParamsModuleJob } from '../models/DatahubLoaderParamsModuleJob';
import type { DataLoaderRequest } from '../models/DataLoaderRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminDatahubLoaderService {

    /**
     * download Data Loader file
     * @returns any Success
     * @throws ApiError
     */
    public static downloadDataHubDataLoaderFile({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<{
        url?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/datahubLoader/file/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * edit Data Loader file
     * @returns any Success
     * @throws ApiError
     */
    public static editDataLoaderFile({
        id,
        requestBody,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
        requestBody: DataLoaderRequest,
    }): CancelablePromise<{
        message?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/admin/datahubLoader/file/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * delete Data Loader file
     * @returns any Success
     * @throws ApiError
     */
    public static deleteDataHubDataLoaderFile({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/datahubLoader/file/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * upload file
     * @returns any Success
     * @throws ApiError
     */
    public static uploadDataHubDataLoaderFile({
        id,
        formData,
    }: {
        /**
         * File Type
         */
        id: string,
        formData: {
            file?: Blob;
        },
    }): CancelablePromise<{
        bucket?: string | null;
        key?: string | null;
        name?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/file/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * rerun process
     * @returns any Success
     * @throws ApiError
     */
    public static dataHubDataLoaderRerunLoad({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: number,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/rerun/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of survey module job files
     * @returns any Success
     * @throws ApiError
     */
    public static listDataLoaderSurveyModuleJobFiles({
        companyId,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        companyId?: (number | string | null),
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/datahubLoader/moduleJob',
            query: {
                'companyId': companyId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Load a survey module job file
     * @returns any Success
     * @throws ApiError
     */
    public static addDataHubDataLoaderModuleJobFile({
        requestBody,
    }: {
        requestBody: DatahubLoaderParamsModuleJob,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/moduleJob',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of survey job rollup files
     * @returns any Success
     * @throws ApiError
     */
    public static listDataLoaderSurveyJobRollupFiles({
        companyId,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        companyId?: (number | string | null),
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/datahubLoader/surveyJobRollup',
            query: {
                'companyId': companyId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of bc level mappings
     * @returns any Success
     * @throws ApiError
     */
    public static listLevelMappings({
        companyId,
        limit,
        offset,
    }: {
        /**
         * Company ID
         */
        companyId?: (number | string | null),
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/datahubLoader/bcLevelMapping',
            query: {
                'companyId': companyId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Load a bc level mapping file
     * @returns any Success
     * @throws ApiError
     */
    public static addFileBcLevelMapping({
        requestBody,
    }: {
        requestBody: DatahubLoaderParamsBcLevelMapping,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/bcLevelMapping',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of survey tenant files
     * @returns any Success
     * @throws ApiError
     */
    public static listDataLoaderSurveyTenantFiles({
        limit,
        offset,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows?: Array<any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/datahubLoader/surveyTenant',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * resume paused load
     * @returns any Success
     * @throws ApiError
     */
    public static resumeLoad({
        id,
    }: {
        /**
         * Data Loader Id
         */
        id: string,
    }): CancelablePromise<{
        message: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/resume/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * pre signed url
     * @returns any Success
     * @throws ApiError
     */
    public static preSignedUrl({
        requestBody,
    }: {
        requestBody: {
            fileType: string;
            fileName: string;
        },
    }): CancelablePromise<{
        url: string;
        bucket: string;
        key: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/datahubLoader/preSignedUrl',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
